import Header from "./header";
import BottomNavigation from "./bottom-navigation";

export const Base = ({
  nav = true,
  children,
}: {
  nav?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div className="fixed h-full flex flex-col">
      <div
        className={`overflow-hidden text-white bg-cover bg-center bg-no-repeat flex-1 flex flex-col justify-end`}
        style={{ backgroundImage: "url(/bg-default.png)" }}
      >
        {nav && <Header />}
        <main className="h-full items-center flex flex-col overflow-y-scroll [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {children}
        </main>
        {nav && (
          <div className="flex justify-center bottom-0">
            <BottomNavigation />
          </div>
        )}
      </div>
    </div>
  );
};

export default Base;
